// extracted by mini-css-extract-plugin
export default {"containprod":"CV","containprod2":"EV","title":"FV","servings":"GV","recommendation":"HV","image":"IV","flavorswrap":"JV","flavorsgroupwrap":"KV","moredetailsWrap":"LV","infoWrap":"MV","price":"NV","regularPrice":"OV","netPrice":"PV","addtocartcontainer":"QV","error":"RV"};
    if(module.hot) {
      // 1743628928131
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  